var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 17.5C2.9165 10.6253 2.9165 7.18798 5.05219 5.05231C7.18786 2.91663 10.6252 2.91663 17.4998 2.91663C24.3744 2.91663 27.8119 2.91663 29.9474 5.05231C32.0832 7.18798 32.0832 10.6253 32.0832 17.5C32.0832 24.3745 32.0832 27.812 29.9474 29.9476C27.8119 32.0833 24.3744 32.0833 17.4998 32.0833C10.6252 32.0833 7.18786 32.0833 5.05219 29.9476C2.9165 27.812 2.9165 24.3745 2.9165 17.5Z",
    stroke: "#FFF000",
    strokeWidth: 2.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1457 13.8542L13.854 21.1458M13.854 13.8541L21.1457 21.1458",
    stroke: "#FFF000",
    strokeWidth: 2.1875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.797e36c04e0cf912a47f426d1abaea55.svg";
export { ForwardRef as ReactComponent };